import Bonuses from './component';

export default Bonuses;
